module.exports = __webpack_public_path__ + "f54c9ba81488d3188b568ad886fd41bd.svg";